import React from "react";
import StatsCard from "./StatCard";

export default function StatsRow({
  totalApplied,
  appliedDelta,
  inProgress,
  inProgressDelta,
  totalAvailable,
  availableDelta,
}: {
  totalApplied: number;
  appliedDelta?: number;
  inProgress: number;
  inProgressDelta?: number;
  totalAvailable: number;
  availableDelta?: number;
}) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
      <StatsCard
        label="Total Grants Applied"
        value={totalApplied}
        deltaPct={appliedDelta}
        icon="task_alt"
        tone="green"
      />
      <StatsCard
        label="Grants in Progress"
        value={inProgress}
        deltaPct={inProgressDelta}
        icon="poll"
        tone="amber"
      />
      <StatsCard
        label="Total Grants available"
        value={totalAvailable}
        deltaPct={availableDelta}
        icon="grid_view"
        tone="blue"
      />
    </div>
  );
}
